// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown_dropdown__1xHVm","trigger":"Dropdown_trigger__3e1Rb","defaultTrigger":"Dropdown_defaultTrigger__bxAMx","panel":"Dropdown_panel__T4CuV"};